<template>
  <div>
    <!-- if this is active route (e.g. /endusers) -->
    <template v-if="isCurrentRoute">
      <entity-entry-header :entityKey="eCurrent.key" :title="$t(`views.${eCurrent.key}.title`)" />

      <entity-entry-table :entityKey="eCurrent.key" :tableSettings="table" searchable>
      </entity-entry-table>
    </template>

    <!-- if subroute is active route (e.g. /endusers/detail) -->
    <section v-else>
      <entity-detail-header :entityKey="eCurrent.key" :entityId="eCurrent.id">
        <template #default="data">
          <dl class="detailheader-list">
            <dt class="sr-only">{{ $t('components.entity.detailheader.name.label') }}</dt>
            <dd>
              <h1>{{ data.entity.firstname }} {{ data.entity.lastname }}</h1>
            </dd>

            <div class="w-100"></div>
            <dt>{{ data.definition.$properties.email.translations[$i18n.locale].name }}</dt>
            <dd>{{ data.entity.email }}</dd>
          </dl>
        </template>
      </entity-detail-header>

      <router-view />
    </section>
  </div>
</template>

<script>
import { CLASS_TABLE_FIELD_KEY_UNKNOWN } from '@/assets/js/config/client'

import { TableHelper } from '@/assets/js/helper/table'

import EntityDetailHeader from '@/components/entity/DetailHeader'
import EntityEntryHeader from '@/components/entity/EntryHeader'
import EntityEntryTable from '@/components/entity/EntryTable'
import MixinEntityBase from '@/components/mixins/EntityBase'

const ENTITY_KEY = 'endusers'

export default {
  name: 'EndUsers',
  mixins: [MixinEntityBase],
  components: {
    EntityEntryHeader,
    EntityEntryTable,
    EntityDetailHeader
  },
  data() {
    return {
      entityKey: ENTITY_KEY,
      table: {
        helper: TableHelper,
        mapper: this.tableEntitiesMapper,
        options: {
          fields: {
            includes: [],
            excludes: [],
            sorting: [CLASS_TABLE_FIELD_KEY_UNKNOWN],
            labelKey: `views.${this.$options.name.toLowerCase()}.table.label.{field}`
          }
        },
        events: {
          rowClicked: this.tableRowClicked
        }
      }
    }
  },
  computed: {
    isCurrentRoute() {
      return Object.values(this.$route.matched[this.$route.matched.length - 1].components).find(c => c.name === this.$options.name) !== undefined
    }
  },
  methods: {
    tableEntitiesMapper(entities) {
      return entities
        .map(e => {
          return Object.assign({}, e, {
            $routerLink: {
              name: `${this.$options.name}.Detail`,
              params: {
                [this.eCurrent.paramKey]: e.id
              }
            }
          })
        })
    },
    tableRowClicked(entity) {
      this.$router.push(entity.$routerLink)
    }
  },
  created() {
    TableHelper.rowClassHook(entity => entity.$routerLink ? 'has-routerlink' : null)
  }
}
</script>

<style lang="scss"></style>
